import { memo, forwardRef, Ref } from 'react';
import css from './Title.module.scss';
import classNames from 'classnames';
import { TitleProps } from './Title.types';
import { GoMotoComponent } from '../../../API/GoMoto.types';

/**
 * The `Title` control that is reponsible for using GoMoto styling
 * for all header tags. By default certain header tags recieve specific theme styling
 * unless specified by the `themeVariant` prop.
 *
 * @param className - {@link TitleProps.className className} description.
 * @param headerLevel - {@link TitleProps.headerLevel headerLevel} description.
 * @param themeVariant - {@link TitleProps.themeVariant themeVariant} description.
 * @param ref - {@link TitleProps.ref ref} description.
 * @param children - {@link TitleProps.children children} description.
 */
const Title: GoMotoComponent<TitleProps> = memo(forwardRef<HTMLHeadingElement, TitleProps>(({
    className,
    headerLevel,
    themeVariant,
    children,
}, ref: Ref<HTMLHeadingElement>) => {
    switch (headerLevel) {
        case 1:
            return (
                <h1 className={classNames(css.title, !themeVariant ? css['heading-1'] : css[themeVariant], className)} ref={ref}>
                    {children}
                </h1>
            );
        case 2:
            return (
                <h2 className={classNames(css.title, !themeVariant ? css['heading-2'] : css[themeVariant], className)} ref={ref}>
                    {children}
                </h2>
            );
        case 3:
            return (
                <h3 className={classNames(css.title, !themeVariant ? css['heading-3'] : css[themeVariant], className)} ref={ref}>
                    {children}
                </h3>
            );
        case 4:
            return (
                <h4 className={classNames(css.title, !themeVariant ? css['heading-4'] : css[themeVariant], className)} ref={ref}>
                    {children}
                </h4>
            );
        case 5:
            return (
                <h5 className={classNames(css.title, !themeVariant ? css['heading-5'] : css[themeVariant], className)} ref={ref}>
                    {children}
                </h5>
            );
        case 6:
            return (
                <h6 className={classNames(css.title, !themeVariant ? css['heading-6'] : css[themeVariant], className)} ref={ref}>
                    {children}
                </h6>
            );
    }
}));

export default Title;